import { render, staticRenderFns } from "./SendCouponResults.vue?vue&type=template&id=7b6e9f88&scoped=true&"
import script from "./SendCouponResults.vue?vue&type=script&lang=js&"
export * from "./SendCouponResults.vue?vue&type=script&lang=js&"
import style0 from "./SendCouponResults.vue?vue&type=style&index=0&id=7b6e9f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e9f88",
  null
  
)

export default component.exports